import { Badge, Box, SimpleGrid, Stack, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import "dayjs/locale/sv";
import styled from "styled-components";
import { formatJobReportStartEnd } from "@utils/utils";
import LoadingIndicator from "./Loading";

dayjs.locale("sv");

// TODO: Phase 4 - Import actual API types
// For now, using inline types based on the API client structure
interface JobReportResponse {
	job: {
		orderNumber: string;
		customer: {
			name: string;
		};
	};
	consultant: {
		firstName: string;
		lastName: string;
	};
	period?: {
		start?: {
			start: string;
		};
		end?: {
			end: string;
		};
	};
	form?: Array<{
		label: string;
		value?: string;
		publishToCustomer: boolean;
	}>;
}

interface Props {
	jobReport: JobReportResponse;
	jobReportForm?: JobReportResponse["form"];
	onRowClick: () => any;
	index: number;
	isExpanded?: boolean;
}

export const JobReportRow: React.FC<Props> = ({ jobReport, onRowClick, index, isExpanded, jobReportForm }) => {
	return (
		<Styles>
			{index === 0 && (
				<SimpleGrid column={{ 0: 2, md: 2 }} minChildWidth="80px" fontWeight="600" mb="2">
					<Box pl="2.5">Uppdrag</Box>
					<Box>Konsult</Box>
				</SimpleGrid>
			)}
			<div className={`main ${isExpanded ? "expanded" : ""}`} onClick={onRowClick}>
				<SimpleGrid column={{ 0: 3, md: 3 }} minChildWidth="80px">
					<VStack alignItems={"flex-start"}>
						<Stack direction={{ base: "column", lg: "row" }} alignItems={"flex-start"}>
							<Badge bg="muted.200">#{jobReport.job.orderNumber}</Badge>
							<Text m="0" fontSize="sm" color="muted.800">
								{formatJobReportStartEnd(jobReport.period?.start?.start || "", jobReport.period?.end?.end || "")}
							</Text>
						</Stack>
						<div className="customer-name">{jobReport.job.customer.name}</div>
					</VStack>

					<Box>
						<div>{jobReport.consultant.firstName + " " + jobReport.consultant.lastName}</div>
					</Box>
				</SimpleGrid>

				{isExpanded && (
					<>
						<VStack
							alignItems={"stretch"}
							w="full"
							minH={"100px"}
							fontSize={"16px"}
							fontWeight={400}
							lineHeight={"19px"}
							pt={"20px"}
							pb="2"
							spacing="4"
						>
							{jobReportForm?.map((item, index) => {
								return (
									item.publishToCustomer && (
										<Box key={index}>
											<div
												style={{
													textDecoration: "underline",
													fontWeight: 600,
													fontSize: "0.9rem",
													marginBottom: 6,
												}}
											>
												{item.label + ":"}
											</div>
											<span className={`field-value ${!item.value ? "field-value-empty" : ""}`}>
												{item.value || "Text saknas"}
											</span>
										</Box>
									)
								);
							})}
							{!jobReportForm && <LoadingIndicator size={"s"} />}
						</VStack>
					</>
				)}
			</div>
		</Styles>
	);
};

const Styles = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	display: flex;
	justify-content: center;
	cursor: pointer;

	.job-dates {
		font-size: ${(props) => props.theme.font.xSmall};
		color: ${(props) => props.theme.colors.textDimmed};
	}

	/* &:nth-child(2n) .main {
		background-color: #f5f5f5;
		border-color: #f5f5f5;
	} */

	.main {
		padding: 10px;
		border: 3px solid #fff;

		&:hover {
			background-color: #f9f9f9;
		}

		&.expanded {
			background-color: #feffec;
		}

		.arrow-container {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			height: 20px;
		}

		.arrow {
			display: none;
		}
	}

	.customer-name {
		line-height: 1.2;
	}

	.clickable {
		margin-left: 15px;
		cursor: pointer;

		&:hover {
			opacity: 0.5;
		}
	}
`;
